import "./GestionUsuarios.scss";
import { ComunicacionAjax } from "../../../ts/api/comunicacion";
import type { Usuario } from "../../../ts/typings/clases";
import { useQuery } from "@tanstack/react-query";
import { TypedTable } from "../../../components/TypedTable";
import { useMemo, useState } from "react";
import { ModalMaquinas } from "./components/ModalMaquinasUsuario";
import { ModalEliminarUsuario } from "./components/ModalEliminarUsuario";
import { ModalEditarUsuario } from "./components/ModalEditarUsuario";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { createColumnHelper } from "@tanstack/react-table";
import { Loading, QueryError } from "../../../components/Loading/Loading";

export function GestionUsuariosPage() {
	const [modalNewUser, setModalNewUser] = useState(false);

	return (
		<div id="content" className="content" >
			<title>Almacen | Listado de usuarios</title>

			<Breadcrumb
				sectionTitle="Listado de Usuarios"
				links={[
					{ label: "Listado de Usuarios", active: true }
				]}
			/>


			<button onClick={() => setModalNewUser(true)} type="submit" className="btnPrimary" style={{ width: "max-content" }}>
				Nuevo usuario
			</button>
			<div>
				<TablaUsuarios />
			</div>
			<ModalEditarUsuario shown={modalNewUser} close={() => setModalNewUser(false)} usuario={null} />
		</div>
	);
}

interface AccionesUsuarioProps {
	readonly usuario: Usuario;
	readonly setModalDelete: (usuario: Usuario) => void;
	readonly setModalEdit: (usuario: Usuario) => void;
	readonly setModalMaquinas: (usuario: Usuario) => void;
}
function AccionesUsuario(props: AccionesUsuarioProps) {
	return (
		<div className="accionesUsuario">
			<button onClick={() => props.setModalEdit(props.usuario)} type="button">
				<i className="fa fa-pen-to-square" />
			</button>
			<button onClick={() => props.setModalDelete(props.usuario)} type="button">
				<i className="fa fa-delete-left" />
			</button>
			{props.usuario.rol == "operario" && (
				<button onClick={() => props.setModalMaquinas(props.usuario)} type="button">
					<i className="fa fa-gear" />
				</button>
			)}
		</div>
	);
}



function TablaUsuarios() {
	const { data, error, isPending } = UseUsuarios();

	const [modalDelete, setModalDelete] = useState<Usuario | null>(null);
	const [modalEdit, setModalEdit] = useState<Usuario | null>(null);
	const [modalMaquinas, setModalMaquinas] = useState<Usuario | null>(null);


	const columns = useMemo(() => {
		const columnHelper = createColumnHelper<Usuario>();

		const dictRol = {
			"jefeFabrica": "Encargado",
			"administracion": "Administración",
			"admin": "Administrador Global",
			"quimico": "Quimico",
			"operario": "Operario",
		};
		const getAccionesUsuario = (usuario: Usuario) => (
			<AccionesUsuario
				usuario={usuario}
				setModalDelete={setModalDelete}
				setModalEdit={setModalEdit}
				setModalMaquinas={setModalMaquinas}
			/>
		);

		return [
			columnHelper.accessor("nombre", { header: "Nombre" }),
			columnHelper.accessor("apellido", { header: "Apellido" }),
			columnHelper.accessor("email", { header: "E-mail" }),
			columnHelper.accessor("rol", { header: "Rol", cell: info => dictRol[info.getValue()] }),
			columnHelper.display({
				id: "acciones",
				header: "",
				meta: {
					className: "p-0 h-full",
				},
				cell: ({ row }) => getAccionesUsuario(row.original),
			}),
			// { title: "", render: (linea) => dictRol[linea.rol] },
		];
	}, []);


	if (error) return <QueryError error={error} fallback="Error cargando los usuarios" />;
	if (isPending) return <Loading />;

	return <>
		<TypedTable
			className="dataTable display"
			data={data}
			columns={columns}
		/>

		<ModalMaquinas shown={modalMaquinas != null} close={() => setModalMaquinas(null)} usuario={modalMaquinas} />
		<ModalEliminarUsuario show={modalDelete != null} close={() => setModalDelete(null)} usuario={modalDelete} />
		<ModalEditarUsuario shown={modalEdit != null} close={() => setModalEdit(null)} usuario={modalEdit} />
	</>;
}


function UseUsuarios() {
	return useQuery<Usuario[]>({
		queryKey: ["getListadoUsuarios"],
		queryFn: () => {
			const url = "/getListadoUsuarios";
			return ComunicacionAjax.sendAjaxRequest<Usuario[]>("GET", url, {});
		},
	});
}